<template>
  <Index/>
</template>

<script>
import Index from './components/home/Index.vue';

export default {
  name: 'App',
  components: {
    Index
  }
};
</script>
